import { render } from "./NewAccountActivation.vue?vue&type=template&id=563b4e9a&scoped=true"
import script from "./NewAccountActivation.vue?vue&type=script&lang=js"
export * from "./NewAccountActivation.vue?vue&type=script&lang=js"

import "./NewAccountActivation.vue?vue&type=style&index=0&id=563b4e9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563b4e9a"]])

export default __exports__